import React, { useState, useEffect } from "react";
import { Card, CardHeader, Button, ListGroup, ListGroupItem, Progress } from "shards-react";

const AreaView = props => {

	const [ AppNames, SetAppNames ] = useState("");

	useEffect(() => {

		const setNames = async () => {

			let AppNames = "";

			props.Area.api_details ? await props.Area.api_details.forEach((AppArea, Index) => {

                AppNames += AppArea.app_name + ", ";
			}) : AppNames = "Not set";

			SetAppNames(AppNames.replace(/(^, )|(, $)/g, ""));
		}

		setNames();
	}, [ props.Area ])

	return (
		<Card small className="mb-4 pt-3">
			<CardHeader className="border-bottom text-center">
				<div className="mb-3 mx-auto">
					{ props.Area.api_details !== false && props.Area.api_details.map((App, Index) => {

						return (
							<>
								<img className="rounded-circle" src={ App.app_icon_url } alt={ props.Area.name } width="55" />
								&nbsp;&nbsp;&nbsp;
							</>
						);
					})}
				</div>
				<h4 className="mb-0">{ props.Area.name }</h4>
				<span className="text-muted d-block mb-2">
					{ AppNames }
				</span>
			</CardHeader>

			<ListGroup flush>
				<ListGroupItem className="px-4">

				</ListGroupItem>
			</ListGroup>
		</Card>
    );
}

export default AreaView;
